import { render, staticRenderFns } from "./dynamicNav.vue?vue&type=template&id=5c089d66&scoped=true"
import script from "./dynamicNav.vue?vue&type=script&lang=js"
export * from "./dynamicNav.vue?vue&type=script&lang=js"
import style0 from "./dynamicNav.vue?vue&type=style&index=0&id=5c089d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c089d66",
  null
  
)

export default component.exports